const scrollToBlocks = document.querySelectorAll('.scroll-to-block');
const contentContainer = document.querySelector('.jumbotron__content');
const buttonsContainer = document.createElement("div");
const isFaq = document.querySelector('.page-template-page-faq');
let scrollOffset = window.innerWidth > 768 ? 84 : 60;
buttonsContainer.classList.add('scroll-links-container');

const createLink = text => {
    const link = document.createElement("a");
    const scrollLinkText = document.createElement("span");
    scrollLinkText.classList.add('scroll-link-text');
    scrollLinkText.innerText = text;
    link.href = '#' + text;
    link.classList.add('scroll-to-link', 'btn-primary', 'jumbotron-button');
    link.appendChild(scrollLinkText);
    return link;
}

const getTitleText = titleElement => titleElement.innerHTML.trim();

if(scrollToBlocks) {
    scrollToBlocks.forEach(scrollToBlock => {
        const blockTitleDOM = scrollToBlock.querySelector('.scroll-to-title');
        scrollToBlock.id = getTitleText(blockTitleDOM);
        buttonsContainer.appendChild(createLink(getTitleText(blockTitleDOM)));
    });
    contentContainer.appendChild(buttonsContainer);
}

if(isFaq) {
    const scrollToTitles = document.querySelectorAll('.scroll-to-title');
    scrollOffset = window.innerWidth > 768 ? 100 : 80;
    scrollToTitles.forEach(scrollToTitle => {
        scrollToTitle.parentNode.id = getTitleText(scrollToTitle);
        buttonsContainer.appendChild(createLink(getTitleText(scrollToTitle)));
    });
    contentContainer.appendChild(buttonsContainer);
}

const scrollLinks = document.querySelectorAll('.scroll-to-link');
if(scrollLinks) {
    scrollLinks.forEach(scrollLink => {
        const scrollLinkText = scrollLink.querySelector('.scroll-link-text').innerHTML;
        const blockElement = document.getElementById(scrollLinkText);

        scrollLink.addEventListener('click', function(e) {
            e.preventDefault();

            window.scroll({
                behavior: 'smooth',
                left: 0,
                top: blockElement.offsetTop - scrollOffset
            });
        });
    });
}


